<template lang="html">
  <LegalDocumentLayout
    :title="item?.title || fallbackTitle"
    :source-key="hasCmsContent ? undefined : 'offer'"
  >
    <InfoCmsBody :item="item" :has-cms-content="hasCmsContent">
      <LegalDocumentBody :blocks="publicOfferBlocks" />
    </InfoCmsBody>
  </LegalDocumentLayout>
</template>

<script setup lang="ts">
import InfoCmsBody from '#Info/components/InfoCmsBody.vue'
import LegalDocumentBody from '#Info/components/LegalDocumentBody.vue'
import LegalDocumentLayout from '#Info/components/LegalDocumentLayout.vue'
import { useInfoCmsPage } from '#Info/composables/useInfoCmsPage'
import { infoCmsSlugs } from '#Info/constants/cmsPages'
import { publicOfferBlocks } from '#Info/content/publicOffer'

defineOptions({
  name: 'InfoOfferPage',
})

const fallbackTitle = 'Публичная оферта'

// текст из CMS по зарезервированному слагу, иначе — встроенный (MR 12a)
const { item, hasCmsContent } = await useInfoCmsPage(infoCmsSlugs.publicOffer)

useContentSeo(item, { fallbackTitle })
</script>
